/* =========================================================================
   Zak's Jewelry — Navigation behaviour
   Mega-menu hover/focus/click with a grace timeout on header mouseleave,
   plus the mobile drawer and its accordions.
   ========================================================================= */

(function () {
  var CLOSE_DELAY = 150;

  function init(root) {
    if (!root || root.dataset.zknReady === 'true') return;
    root.dataset.zknReady = 'true';

    var header = root.querySelector('[data-zkn-header]');
    var ann = root.querySelector('[data-zkn-ann]');
    var triggers = Array.prototype.slice.call(root.querySelectorAll('[data-zkn-trigger]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-zkn-panel]'));
    var closeTimer = null;

    /* --- sticky offset: let the announcement bar scroll away, pin the header --- */
    var wrapper = root.closest('.shopify-section') || root;

    // The drawer is a SIBLING of root, not a descendant, so it must be looked up
    // from the section wrapper. Querying it from root finds nothing.
    var scope = wrapper;
    var drawer = scope.querySelector('[data-zkn-drawer]');
    function syncOffset() {
      var h = ann ? ann.offsetHeight : 0;
      wrapper.style.setProperty('--zkn-ann-h', h + 'px');
    }
    syncOffset();
    if (window.ResizeObserver && ann) new ResizeObserver(syncOffset).observe(ann);

    /* --- scrolled state --- */
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        root.classList.toggle('is-scrolled', window.scrollY > 8);
        ticking = false;
      });
    }
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    /* --- mega-menu ---------------------------------------------------- */

    function panelFor(trigger) {
      return root.querySelector('#' + trigger.getAttribute('aria-controls'));
    }

    // Class + inline styles together, so an unexpected cascade can't strand a
    // panel half-open (it is hidden with visibility, not display).
    function setPanel(panel, open) {
      if (!panel) return;
      panel.classList.toggle('is-open', open);
      panel.style.opacity = open ? '1' : '0';
      panel.style.visibility = open ? 'visible' : 'hidden';
      panel.style.transform = open ? 'translateY(0)' : 'translateY(-10px)';
    }

    function closeAll() {
      triggers.forEach(function (t) {
        t.setAttribute('aria-expanded', 'false');
      });
      panels.forEach(function (p) {
        setPanel(p, false);
      });
    }

    function open(trigger) {
      closeAll();
      trigger.setAttribute('aria-expanded', 'true');
      setPanel(panelFor(trigger), true);
    }

    function cancelClose() {
      if (closeTimer) {
        clearTimeout(closeTimer);
        closeTimer = null;
      }
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('mouseenter', function () {
        cancelClose();
        open(trigger);
      });
      trigger.addEventListener('focus', function () {
        cancelClose();
        open(trigger);
      });
      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        var isOpen = trigger.getAttribute('aria-expanded') === 'true';
        cancelClose();
        if (isOpen) closeAll();
        else open(trigger);
      });
    });

    // The grace period is what lets the cursor travel from a trigger down into
    // the panel without the panel snapping shut on the way.
    if (header) {
      header.addEventListener('mouseenter', cancelClose);
      header.addEventListener('mouseleave', function () {
        cancelClose();
        closeTimer = setTimeout(closeAll, CLOSE_DELAY);
      });
    }

    panels.forEach(function (panel) {
      panel.addEventListener('mouseenter', cancelClose);
      panel.addEventListener('click', function (event) {
        if (event.target.closest('a')) closeAll();
      });
    });

    /* --- mobile drawer ------------------------------------------------ */

    function setDrawer(open) {
      if (!drawer) return;
      drawer.classList.toggle('is-open', open);
      drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
      document.body.style.overflow = open ? 'hidden' : '';
      var burger = root.querySelector('[data-zkn-burger]');
      if (burger) burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    root.querySelectorAll('[data-zkn-burger]').forEach(function (el) {
      el.addEventListener('click', function () {
        setDrawer(true);
      });
    });
    scope.querySelectorAll('[data-zkn-drawer-close]').forEach(function (el) {
      el.addEventListener('click', function () {
        setDrawer(false);
      });
    });

    if (drawer) {
      drawer.addEventListener('click', function (event) {
        var link = event.target.closest('a');
        if (link && link.getAttribute('href')) setDrawer(false);
      });
    }

    scope.querySelectorAll('[data-zkn-acc]').forEach(function (head) {
      head.addEventListener('click', function () {
        var panel = head.nextElementSibling;
        var isOpen = head.getAttribute('aria-expanded') === 'true';
        head.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        if (panel) panel.classList.toggle('is-open', !isOpen);
      });
    });

    /* --- escape ------------------------------------------------------- */

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      closeAll();
      if (drawer && drawer.classList.contains('is-open')) setDrawer(false);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-zkn-root]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Theme editor re-renders the section without a page load.
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-zkn-root]');
    if (root) init(root);
  });
  document.addEventListener('shopify:section:unload', function () {
    document.body.style.overflow = '';
  });
})();
